import React, { useRef, useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { components, constants } from 'cng-web-lib'
import { A6ATranslationContext } from './contexts/A6ATranslationContext'
import Box from '@material-ui/core/Box'
import TaciOcnA6aSNFormProperties from './TaciOcnA6aSNFormProperties'


const {
    button: { CngPrimaryButton },
    form: { CngForm },
    CngDialog
} = components

const { FormState } = constants

function TaciOcnA6aSNDialog(props) {
    const { open, onClose, sn } = props
    const { getValues, setValue, formState: { isSubmitting } } = useFormContext()
    const { getTranslatedText } = useContext(A6ATranslationContext)

    const lastIndex = useRef(0)

    const { initialValues, makeValidationSchema } = TaciOcnA6aSNFormProperties.formikProps

    function handleAddSN(data) {
        const taciOcnA6aSN = [...getValues('taciOcnA6aSN'), data].map(
            (sn) => ({ ...sn, _id: ++lastIndex.current })
        )

        setValue('taciOcnA6aSN', taciOcnA6aSN)
        onClose()
    }

    function handleEditSN(data) {
        const taciOcnA6aSN = [...getValues('taciOcnA6aSN')]
        const index = taciOcnA6aSN.findIndex((taciOcnA6aSN) => taciOcnA6aSN.id ? taciOcnA6aSN.id === data.id : taciOcnA6aSN._id === data._id)

        taciOcnA6aSN[index] = data

        setValue('taciOcnA6aSN', taciOcnA6aSN)
        onClose()
    }

    return (
        <CngDialog
            dialogContent={
                <CngForm
                    fieldLevel='form'
                    formikProps={{
                        initialValues: sn || initialValues,
                        makeValidationSchema: makeValidationSchema,
                        onSubmit: (data) => {
                            if (sn) {
                                handleEditSN(data)
                            } else {
                                handleAddSN(data)
                            }
                        }
                    }}
                    formState={FormState.COMPLETED}
                    innerForm={true}
                    renderBodySection={(labelMap, shouldHideMap) => (
                        <TaciOcnA6aSNFormProperties.Fields shouldHideMap={shouldHideMap} />
                    )}
                    renderButtonSection={() => (
                        <Box display='flex' justifyContent='flex-end'>
                            <CngPrimaryButton type='submit' disabled={isSubmitting}>
                                {sn ? "Update" : "Save"}
                            </CngPrimaryButton>
                        </Box>
                    )}
                />
            }
            dialogTitle={getTranslatedText('A6A', 'taciOcnA6aSN')}
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            fullWidth
            maxWidth='lg'
            onClose={onClose}
            open={open}
            shouldShowCloseButton
        />
    )
}

export default TaciOcnA6aSNDialog
